import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

type ModalName = 'store-category-list' | 'product-category-list';

/**
 * 지정된 모달의 열림/닫힘 상태를 관리하며, 모달이 열린 경우 뒤쪽 컴포넌트의 스크롤을 방지합니다.
 */
const useModal = (modalName: ModalName) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isOpen = searchParams.get('modal') === modalName;

  const openModal = () => {
    navigate({
      pathname: '.',
      search: `?modal=${modalName}`,
    });
  };

  useEffect(() => {
    if (isOpen) {
      const htmlElement = document.getElementById('main-div') as HTMLElement;
      const currentScroll = htmlElement.scrollTop;
      htmlElement.classList.add('no-scroll');
      htmlElement.style.top = `-${currentScroll}px`;
    } else {
      const htmlElement = document.getElementById('main-div') as HTMLElement;
      const scrollY = htmlElement.style.top;
      htmlElement.classList.remove('no-scroll');
      htmlElement.style.top = 'auto';
      htmlElement.scrollTo({
        top: parseInt(scrollY || '0') * -1,
        behavior: 'instant' as any,
      });
    }

    return () => {
      const htmlElement = document.getElementById('main-div') as HTMLElement;
      htmlElement.classList.remove('no-scroll');
    };
  }, [isOpen]);

  return {
    isOpen,
    openModal,
  };
};

export default useModal;
